import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown, Compass, Sparkles } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { NAV, DESKTOP_VOLGORDE, navTestid } from "./navConfig";

// v19-N1: smaller (13px, normale spatiëring, px-2, iconen 3.5) zodat de balk op 1280+ past; hoogte en onderstreping gelijk.
const TAB = "flex items-center gap-1 px-2 py-2.5 text-[13px] leading-5 font-medium uppercase border-b-2 whitespace-nowrap shrink-0 transition-colors";
const UIT = "border-transparent text-zinc-500 hover:text-zinc-200";

const Badge = ({ n, count }) => count > 0 && (
  <span data-testid={n.badgeTestid} title={n.badgeTitle ? `${n.badgeTitle}: ${count}` : undefined}
    className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold leading-none font-mono">{count}</span>
);

const openIntro = () => window.dispatchEvent(new CustomEvent("onboarding:open-intro"));
const openChangelog = () => window.dispatchEvent(new CustomEvent("onboarding:open-changelog"));

// v18 A2: desktop houdt de tabs; minder gebruikte items onder "Meer ▾", zodat er op 1366/1920 niets wegvalt.
export const DesktopNav = ({ user, counts, onbHasNew }) => {
  const { pathname } = useLocation();
  const items = DESKTOP_VOLGORDE.map((k) => NAV[k]).filter((n) => n.roles.includes(user.role));
  const zicht = items.filter((n) => !n.meerDesktop);
  const meer = items.filter((n) => n.meerDesktop);
  const meerActief = meer.some((n) => pathname.startsWith(n.to));
  return (
    <nav data-testid="desktop-nav" className="hidden md:flex max-w-7xl mx-auto px-2 md:px-8 gap-0.5 overflow-x-auto xl:overflow-x-visible border-t border-white/5">
      {zicht.map((n) => (
        <NavLink key={n.to} to={n.to} data-testid={navTestid(n)}
          className={({ isActive }) => `${TAB} ${isActive ? "border-white text-white" : UIT}`}>
          <n.icon className="h-3.5 w-3.5" /> {n.label}
          <Badge n={n} count={n.countKey ? counts[n.countKey] || 0 : 0} />
        </NavLink>
      ))}
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger data-testid="nav-meer" className={`${TAB} focus:outline-none ${meerActief ? "border-white text-white" : UIT}`}>
          Meer <ChevronDown className="h-3.5 w-3.5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[200px]">
          {meer.map((n) => (
            <DropdownMenuItem key={n.to} asChild>
              <NavLink to={n.to} data-testid={navTestid(n)} className="flex items-center gap-2 cursor-pointer"><n.icon className="h-4 w-4" />{n.label}</NavLink>
            </DropdownMenuItem>
          ))}
          <DropdownMenuItem data-testid="onboarding-open-intro" onSelect={openIntro} className="flex items-center gap-2 cursor-pointer">
            <Compass className="h-4 w-4" /> Intro
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <button data-testid="onboarding-open-changelog" onClick={openChangelog} aria-label="Wat is er nieuw" title="Wat is er nieuw" className={`relative ${TAB} ${UIT}`}>
        <Sparkles className="h-3.5 w-3.5" />
        {onbHasNew && <span data-testid="changelog-new-dot" className="h-2 w-2 rounded-full bg-rose-500" />}
      </button>
    </nav>
  );
};
